export enum ContactFilterConditionalOperator {
  "AND" = " AND ",
  "OR" = " OR ",
}

export enum ContactFilterOperator {
  // 'Choose one' = '',
  "Equals" = "EQUALS",
  "Not equals" = "NOTEQUALS",
  "Greater than" = "GREATER",
  "Less than" = "LESS",
  "Starts with" = "STARTS",
  "Ends with" = "ENDS",
  "Contains" = "CONTAINS",
}

export class ContactFilter {
  contactFilterId: string;
  contactFilterName: string;
  filterQuery: string;
  userId?: number;
  contactFolderId: string;
  description: string;
  filterUiState: object;

  constructor() {
    this.contactFilterId = "";
    this.contactFilterName = "";
    this.filterQuery = "";
    this.description = "";
    this.contactFolderId = "";
    this.filterUiState = {};
  }
}

export class ContactFilterForm {
  condition?: ContactFilterConditionalOperator;
  field: string;
  operator: ContactFilterOperator;
  value: string;
  fieldError: string;
  valueError: string;
  [index: string]: any;

  constructor() {
    this.condition = ContactFilterConditionalOperator.AND;
    this.field = "";
    this.operator = ContactFilterOperator.Equals;
    this.value = "";
    this.fieldError = "";
    this.valueError = "";
    this.type = "filter";
  }
}

export interface ContactFilterGroupFormList {
  condition?: ContactFilterConditionalOperator;
  field: string;
  operator: ContactFilterOperator;
  value: string;
  fieldError: string;
  valueError: string;
  [index: string]: any;
}

export class ContactFilterGroupForm {
  type: string;
  list: ContactFilterGroupFormList[];
  constructor() {
    this.type = "group";
    this.list = [
      {
        condition: ContactFilterConditionalOperator.AND,
        field: "",
        operator: ContactFilterOperator.Equals,
        value: "",
        fieldError: "",
        valueError: "",
        type: "filter",
      },
    ];
  }
}

export class ContactFilterJointForm {
  condition?: ContactFilterConditionalOperator;
  field: string;
  operator: ContactFilterOperator;
  value: string;
  fieldError: string;
  valueError: string;
  [index: string]: any;

  constructor() {
    this.condition = ContactFilterConditionalOperator.AND;
    this.field = "";
    this.operator = ContactFilterOperator.Equals;
    this.value = "";
    this.fieldError = "";
    this.valueError = "";
    this.type = "joint";
  }
}

export enum SearchableContactFields {
  "First name" = "firstName",
  "Last name" = "lastName",
  "Mobile" = "mobile",
  "Email" = "email",
  "Fax" = "fax",
  "Pager" = "pager",
  "IM" = "im",
  "Responder ID" = "responderId",
  "Company" = "company",
  "Department" = "department",
  "City" = "city",
  "County" = "county",
  "Postcode" = "postcode",
  "Role" = "role",
  "Cost centre" = "costCentre",
}
